import React from 'react';

import squadeal from '../assets/images/squadeal/squadeal.png';

const Squadeal = ({ isVisible }) => {
    const animation = isVisible ? 'animated-1' : '';
    const animation1 = isVisible ? 'animated-3' : '';
    const animation2 = isVisible ? 'animated-4' : '';

    return (
      <div className="portfolio reverse container">
        <div className="showcase_wrap">
          <div className="project">
            <img src={squadeal} className={"no-opacity " + animation} alt="Squadeal" />
          </div>
          <div className="project_bg">
            <svg viewBox="0 0 1900 1900" className={"svg_bg no-opacity " + animation2} xmlns="http://www.w3.org/2000/svg">
              <path d="M1763.27064,1303.42896 C1567.99268,1621.80043 1149.04117,1823.48793 776.639829,1769.18745 C443.030293,1714.88697 16.3204197,1575.25716 24.078781,1164.12496 C24.078781,1094.31005 0.803697038,1024.49515 0.803697038,962.437457 C-8.06410996,749.664904 56.5397648,516.638272 190.262881,344.397149 C206.974391,322.86313 224.772072,302.283248 243.640406,282.812647 C512.855544,-46.0000326 1024.90739,-77.0288784 1374.03365,132.415831 C1668.85138,310.831695 1955.91075,628.877365 1836.10614,1000.49434 C1829.79859,1025.91472 1826.43146,1052.52971 1822.64538,1079.19125 C1815.09649,1132.50656 1803.55205,1184.71259 1788.73358,1234.46735 C1781.43296,1257.60711 1773.13927,1280.70809 1763.27064,1303.42896" fill="#e14444">
              </path>
            </svg>
          </div>
        </div>
        <div className={"showcase_desc no-opacity " + animation1}>
          <h2>Squadeal</h2>
          <p>A better deal starts in your group chat. Create a squad, drop the link in your group chat, and watch group pricing unlock as more friends join. No chasing required.</p>

          <p className="my-role">My Role: Design & Development</p>
          <p className="year-completed">Year of Completion: 2026</p>
          <p><a className="cta-btn" href="https://squadeal.com" target="_blank" rel="noopener noreferrer" id="squadeal_cta">Squadeal</a></p>
        </div>
      </div>
    )
}

export default Squadeal



// WEBPACK FOOTER //
// ./src/components/Squadeal.js